module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/loading_cm.699245d0.svg";